import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { initSentry } from '@/lib/sentry';
import { purgeLegacyKeys } from '@/lib/store/persistence';
// Import globals.css from current location (will move to src/globals.css in Phase 7-8)
import '@/app/globals.css';

// Initialize Sentry error tracking before rendering
initSentry();

// Purge legacy localStorage keys that contained PII (v1 had full store including crew data).
// Must run before hydration so existing users' sensitive data is deleted.
purgeLegacyKeys();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>
);
